module.exports = __webpack_public_path__ + "static/assets/ace767df9a3f8b309d6f873c01afb4e4.gif";